import { VehicleReport } from './vehicle-report';

export class VehicleOffCourseReport extends VehicleReport { }
